import React from "react"
import { Grid, Typography } from "@material-ui/core"
import CodeIcon from "@material-ui/icons/Code"
import copy from "copy-to-clipboard"

import { ActionDialog, JsonEditor, Notification } from "@/components"

import useStyles from "@/pages/Admin/Automation/Webhook/Configure/components/PayloadExampleDialog/styles"

type PayloadExampleDialogProps = {
	open: boolean
	title: string
	exampleJson: string
	onClose: () => void
}

const PayloadExampleDialog: React.FC<PayloadExampleDialogProps> = (props) => {
	const {
		open,
		title,
		exampleJson,
		onClose
	} = props

	const classes = useStyles()

	const handleCopyJson = () => {
		copy(exampleJson)
		Notification.success({ message: "JSON copiado!" })
	}

	return (
		<ActionDialog
			title={title}
			cancelText="FECHAR"
			saveText="COPIAR JSON"
			openDialog={open}
			onSave={handleCopyJson}
			onClose={onClose}
			dialogTitleClassName={classes.title}
			fullWidth
		>
			<Grid container direction="column" className={classes.codeBlock}>
				<Grid item container alignItems="center" spacing={1} className={classes.codeHeaderLabel}>
					<CodeIcon fontSize="small" />
					<Typography variant="caption" className={classes.codeHeaderLabelText}>
						JSON
					</Typography>
				</Grid>
				<Grid item>
					<JsonEditor
						defaultValue={exampleJson}
						height="320px"
						readOnly
					/>
				</Grid>
			</Grid>
		</ActionDialog>
	)
}

export default PayloadExampleDialog
